var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{directives:[{name:"loading",rawName:"v-loading",value:(false),expression:"false"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }